import { Grid2 as Grid, Card, CardContent, IconButton, Divider } from "@mui/material"
import { Edit, Delete } from "@mui/icons-material"
import { Copia } from "../types"
import { InlineField } from "./DataField"
import { useTranslation } from "react-i18next"
import useUserCanWriteAndDelete from "../hooks/permissions"
import { useIsMobile } from "../hooks/mobile"

type CopiaCardProps = {
  copia: Copia
  onDelete: (copia: Copia) => void
  onUpdate: (copia: Copia) => void
}

export default function CopiaCard({ copia, onDelete, onUpdate }: CopiaCardProps) {
  const { t } = useTranslation()
  const userCanWriteAndDelete = useUserCanWriteAndDelete()
  const isMobile = useIsMobile()

  return (
    <Card>
      <CardContent sx={{ position: "relative" }}>
        {userCanWriteAndDelete && !isMobile && (
          <IconButton
            onClick={() => onUpdate(copia)}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "primary.main",
            }}
            aria-label="edit"
          >
            <Edit />
          </IconButton>
        )}
        <InlineField label={t("general.formato")} value={copia.formato_data?.nome} />
        <InlineField label={t("general.data")} value={copia.data} />

        <Divider sx={{ marginY: 2 }} />

        <InlineField label={t("copia.esterna")} value={copia.esterna} boolean />
        <InlineField label={t("copia.lab")} value={copia.lab} />
        <InlineField label={t("general.luogo")} value={copia.luogo_data?.nome} />

        <Grid container spacing={2}>
          <Grid size={6}>
            <InlineField label={t("copia.uscita")} value={copia.uscita} />
          </Grid>
          <Grid size={6}>
            <InlineField label={t("copia.rientro")} value={copia.rientro} />
          </Grid>
        </Grid>

        <Divider sx={{ marginY: 2 }} />

        <InlineField label={t("copia.intervento")} value={copia.note} />
        <InlineField label={t("general.note")} value={copia.note} />
        {userCanWriteAndDelete && !isMobile && (
          <IconButton
            onClick={() => onDelete(copia)}
            sx={{
              position: "absolute",
              bottom: 8,
              right: 8,
              color: "error.main",
            }}
            aria-label="delete"
          >
            <Delete />
          </IconButton>
        )}
      </CardContent>
    </Card>
  )
}
